var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('div',{attrs:{"id":"video"}},[_c('video-tagger',{attrs:{"video":_vm.video}}),_c('video-info',{attrs:{"video":_vm.video,"event":_vm.event}}),_c('tag-list',{attrs:{"tags":_vm.tags}}),_c('new-tag-dialog')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1047e23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Video.vue
// module id = amq5
// module chunks = 1